<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row flex-grow">
                <div class="vx-col md:w-1/4 w-full pr-4">
                    <label class="vs-input--label">{{this.$t('overTime.branch')}}</label>
                    <v-select class="" v-model="selectedOrganizationBranch"
                            :options="organizationBranchOptions">
                            <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                </div>
                <div style="display:inline-block" class="vx-col md:w-1/4 sm:w-auto pr-4">
                    <label class="vs-input--label">{{this.$t('overTime.employee')}}</label>
                    <v-select class="" v-model="selectedEmployee" :clearable="false" :options="employeeOptions">
                        <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                </div>
                <div style="display:inline-block" class="vx-col md:w-1/4 sm:w-auto pr-2">
                    <label class="vs-input--label">{{this.$t('overTime.status')}}</label>
                    <v-select class="" v-model="overtimeStatusModel" :clearable="false" :options="overtimeStatusOptions">
                        <span slot="no-options">{{$t('menuOrganization.emptyList')}}</span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/4" style="display: inline-block">
                    <label class="vs-input--label">{{this.$t('overTime.times')}}</label>
                    <date-range-picker
                        ref="picker"
                        :locale-data="{format: 'dd/mm/yyyy' }"
                        :opens="'left'"
                        v-model="dateRange" class="w-full">
                    </date-range-picker>
                </div>
            </div>

            <div class="vx-row mt-5">
                <div class="vx-col md:w-1/2">
                    <div class="flex">
                        <vs-button @click="getListOverTime" color="primary" iconPack="feather" icon="icon-search" class="mr-5">{{ $t('menuPackage.search') }}</vs-button>
                        <vs-button
                            v-if="isPermissionAdd()"
                            @click="addOvertime"
                            color="primary"
                            icon-pack="feather"
                            icon="icon-plus">
                            {{this.$t('overTime.createWork')}}
                        </vs-button>
                        <vs-button iconPack="feather" icon="icon-download" class="ml-5" @click="generateReport">{{ $t('updateInout.export') }}</vs-button>
                    </div>
                </div>
                <!-- ITEMS PER PAGE -->
                <div class="vx-col md:w-1/4">
                    <Pagination class="float-right"
                    :itemList="listOvertime"
                    :currentPage="currentPage"
                    :paginationPageSize="paginationPageSize"
                    :gridApi="gridApi"
                />
                </div>
                <div class="vx-col md:w-1/4">
                    <vs-input class="sm:w-auto w-full"
                        v-model="searchQuery"
                          :placeholder="$t('button.search')"/>
                </div>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="listOvertime"
                         :animateRows="true"
                         :pagination="true"
                         :localeText=" {noRowsToShow: this.$t('menuCamera.noRowsToShow')} "
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"/>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from 'moment';
import Pagination from "../../../ui-elements/Pagination.vue";
import Datepicker from 'vuejs-datepicker';
import DateRangePicker from '../../../../components/vue2-daterange-picker/components/DateRangePicker.vue';
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import CellRendererActions from './cell-renderer/CellRendererActions.vue';
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {
    components:{
        vSelect,
        AgGridVue,
        Pagination,
        Datepicker,
        DateRangePicker,
        CellRendererStatus,
        CellRendererActions
    },
    data(){
        return {
            //branch
            organizationBranchOptions: [],
            organizationSubBranchOptions: [],
            organizationChilrenBranchOptions: [],
            selectedOrganizationBranchValue: null,
            levelBranch: null,

            //employee
            selectedEmployeeValue: null,
            employeeOptions: [],

            //date range
            dateRange: {
                startDate: moment().startOf('days').toDate(),
                endDate: moment().add(6, 'days').endOf('days').toDate(),
            },

            //over time
            listOvertime: [],
            overtimeStatusOptions: [
                {value: null, label: this.$t('menuOrganization.all')},
                {value: 0, label: 'Chờ'},
                {value: 1, label: 'Đã duyệt'},
                {value: 2, label: 'Từ chối'},
                {value: 3, label: 'Hủy bỏ'}
            ],

            //pagination
            maxPageNumbers: 7,
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('overTime.employeeCode'),
                    field: 'employeeId',
                    width: 120
                },
                {
                    headerName: this.$t('overTime.employeeName'),
                    field: 'employeeFullName',
                    width: 180
                },
                {
                    headerName: this.$t('overTime.branchName'),
                    field: 'branchName',
                    width: 180
                },
                {
                    headerName: this.$t('overTime.createDate'),
                    field: 'createdDate',
                    width: 180
                },
                {
                    headerName: this.$t('overTime.status'),
                    field: 'displayStatus',
                    cellRendererFramework: 'CellRendererStatus',
                    width: 120,
                },
                {
                    headerName: this.$t('overTime.reseon'),
                    field: 'reason',
                    width: 200,
                },
                {
                    headerName: this.$t('overTime.actions'),
                    field: 'actions',
                    width: 170,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            components: {

            },

            //search
            searchQuery: null,
            status: null,
            branchList: []

        }
    },
    watch: {
        '$store.state.isUpdateOvertime'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_OVERTIME', false);
            }
        }
    },
    computed: {
        overtimeStatusModel: {
            get() {
                let object = this.overtimeStatusOptions.find(el => el.value === this.status);
                return {
                    label: object ? object.label : 'Chưa xác định',
                    value: this.status
                }
            },
            set(obj) {
                this.status = obj.value;
            }
        },
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.selectedOrganizationBranchValue, this.organizationBranchOptions),
                    value: this.selectedOrganizationBranchValue
                }
            },
            set(obj) {
                this.selectedOrganizationBranchValue = obj ? obj.value : null;
                this.loadEmployee();
            }
        },
        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.selectedEmployeeValue),
                    value: this.selectedEmployeeValue
                }
            },
            set(obj) {
                this.selectedEmployeeValue = obj.value
            }
        },
    },
    methods:{
        isPermissionAdd() {
            return isAPI(this, constAPI.over_time_add);
        },
        addOvertime: function(){
            this.$router.push('/user/over-time');
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        getListOverTime: function(){
            let payload = {
                employeeId: this.selectedEmployeeValue,
                fromTime: moment(this.dateRange.startDate).startOf('days').toDate(),
                toTime: moment(this.dateRange.endDate).endOf('days').toDate(),
                organizationBranchId: this.selectedOrganizationBranchValue,
                status: this.status
            }

            this.$vs.loading();
            this.$crm.post('over-time/findAll', payload).then((res) => {
                let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
                let result = res.data;
                this.listOvertime = result.map(item => {
                    item.displayStatus = item.status == 0 ? 'Chờ' : item.status == 1 ? 'Đã duyệt' : item.status == 2 ? 'Từ chối' : 'Hủy';
                    item.createdDate = moment(item.createdDate).format('DD/MM/YYYY')
                    branchList.forEach(el => {
                        if (el.id == item.organizationBranchId) item.branchName = el.organizationBranchName
                    })
                    return item;
                });
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
            })
        },
        loadEmployee() {
            this.$vs.loading();
            let path = this.selectedOrganizationBranchValue ? `/employee/find-by-organization-branch/${this.selectedOrganizationBranchValue}?isEnabled=true` : '/employee/find-by-organization-branch'
            this.$crm.post(path).then((response) => {
                this.employeeData = response.data;
                this.employeeOptions = response.data.map(item => {
                    return {
                        value: item.employeeId,
                        label: item.employeeCode + " " + item.fullName,
                        ...item
                    }
                });
                this.employeeOptions.unshift({value: null, label: this.$t('menuOrganization.all')})
                this.$vs.loading.close();
                this.getListOverTime();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        organizationBranchString(id, data) {
            if (!id) this.valueSelectedBranch = id;
            let organizationBranch = data.find(x => x.value == id);
            return (organizationBranch && organizationBranch.label) || 'Chưa xác định';
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value == id);
            return (employee && employee.label) || 'Chưa xác định';
        },
        initScreen(){
            let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
            if (branchList.length === 0) {
                return this.$vs.notify({
                    text: 'Hiện tại không tồn tại chi nhánh nào',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            }
            this.organizationBranchOptions = branchList.map(item => {
                return {value: item.id, label: item.organizationBranchName}
            });
            let branchId = this.$route.query.branch_id;
            let index = 0;
            if (branchId) {
                index = this.organizationBranchOptions.findIndex(item => item.value == branchId)
            }
            this.selectedOrganizationBranch = this.organizationBranchOptions[index > -1 ? index : 0];
            this.loadEmployee();
        },

        generateReport() {
            this.$vs.loading()
            let data = {
                employeeId: this.selectedEmployeeValue,
                fromTime: moment(this.dateRange.startDate).startOf('days').toDate(),
                toTime: moment(this.dateRange.endDate).endOf('days').toDate(),
                organizationBranchId: this.selectedOrganizationBranchValue,
                status: this.status
            }

            this.$crm.post('/over-time/export', data).then(res => {
                window.open(authConfig.crmDomain + "file/" + res.data.fileName + "?access_token=" + localStorage.getItem("access_token"), "_blank");
                this.$vs.loading.close()
            }).catch(err => {
                this.$vs.loading.close()
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        }
    },
    async created(){
        this.initScreen();
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style>

</style>
